var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgAccentTable = (props, ref) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 102,
  height: 102,
  fill: "none",
  ref: ref
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  cx: 51,
  cy: 51,
  r: 50,
  stroke: "#CEB384",
  strokeWidth: 2
})), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#CEB384",
  strokeLinecap: "round",
  strokeWidth: 2,
  d: "m61 69-1.73-4.154A3 3 0 0 0 56.5 63h-11a3 3 0 0 0-2.77 1.846L41 69M51 51v18"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#CEB384",
  strokeWidth: 2,
  d: "M70 41c0 2.179-1.792 4.42-5.305 6.177C61.242 48.903 56.4 50 51 50s-10.242-1.097-13.695-2.823C33.792 45.42 32 43.179 32 41c0-2.179 1.792-4.42 5.305-6.177C40.758 33.097 45.6 32 51 32s10.242 1.097 13.695 2.823C68.208 36.58 70 38.821 70 41Z"
})));
SvgAccentTable.viewBox = null;
const ForwardRef = /*#__PURE__*/forwardRef(SvgAccentTable);
export default ForwardRef;